module.exports = new __parcel__URL__("homepage2.0dd25c36.png").toString();